export const Endpoint = "https://oridsan-server.fly.dev/api/v1";
